import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCurrentUser } from '../api/authApi';
import { ROLES } from '../constants/roles';
import { authUserSynced } from './authSlice';

export const loadCurrentUser = createAsyncThunk('auth/loadCurrentUser', async (_, { dispatch }) => {
  try {
    const me = await fetchCurrentUser();
    dispatch(
      authUserSynced({
        user: {
          first_name: me.first_name ?? null,
          last_name: me.last_name ?? null,
          is_admin: me.is_admin ?? false,
          tenant_id: me.tenant_id ?? null,
          tenant_name: me.tenant_name ?? null,
        },
        role: me?.role ?? ROLES.VIEWER,
      }),
    );
  } catch {
    dispatch(authUserSynced({ user: null, role: ROLES.VIEWER }));
  }
});
